import { TFunction } from 'i18next'
import * as yup from 'yup'

export const DEFAULT_REMEDIAL =
    '<ul><li><p>Cách khắc phục/ Giải pháp:  </p></li></ul>'

export const resolvedSchema = (t: TFunction<'translation', undefined>) =>
    yup.object().shape({
        ticket_remedial_measures: yup.object().shape({
            text: yup
                .string()
                .required(t('blank-errors'))
                .test(
                    'not-equal-default-remedial',
                    t('blank-errors'),
                    (value) => {
                        const normalized = value
                            ?.replace(/\s+/g, '')
                            .toLowerCase()
                        const defaultNormalized = DEFAULT_REMEDIAL.replace(
                            /\s+/g,
                            ''
                        ).toLowerCase()
                        return normalized !== defaultNormalized
                    }
                ),
            attachments: yup.array().of(yup.mixed()).notRequired(),
        }),
        ticket_time_release: yup.mixed().notRequired(),
    })
